import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { fontSize } from '../../../../styles/themes/vad/font';

const useStyles = makeStyles(theme => {
  const { right, left, paddingLR } = theme.mixins;
  return {
    root: {
      paddingTop: theme.spacing(4),
      ...paddingLR(theme.spacing(3), theme.spacing(3)),

      '& h2': {
        marginTop: theme.spacing(7),
        marginBottom: theme.spacing(3),

        [theme.breakpoints.up('lg')]: {
          marginTop: theme.spacing(6),
          marginBottom: theme.spacing(4),
        },
      },
      [theme.breakpoints.up('lg')]: {
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(6),
        ...paddingLR(theme.spacing(6), theme.spacing(6)),
      },
    },
    title: {
      margin: 0,
      [theme.breakpoints.up('lg')]: {
        fontSize: fontSize.s48Rem,
        lineHeight: fontSize.s56Rem,
      },
    },
    popupCTAButton: {
      position: 'absolute',
      ...right(0),
      top: pxToRem(32),
      [theme.breakpoints.up('lg')]: {
        top: pxToRem(11),
      },
      '& .MuiButton-endIcon': {
        width: pxToRem(36),
        height: pxToRem(36),
        position: 'relative',

        [theme.breakpoints.up('lg')]: {
          width: pxToRem(48),
          height: pxToRem(48),
        },
        '& .MuiSvgIcon-root': {
          [theme.breakpoints.down('md')]: {
            position: 'absolute',
            top: pxToRem(8),
            ...left(pxToRem(9)),
          },

          [theme.breakpoints.up('lg')]: {
            width: pxToRem(24),
            height: pxToRem(24),
          },
        },
      },
    },
    searchPopupInput: {
      position: 'relative',
      margin: 0,

      [theme.breakpoints.up('lg')]: {
        marginTop: pxToRem(22),
      },
      '& .MuiGrid-root': {
        '& fieldset': {
          width: '100%',
          marginTop: pxToRem(14),
          [theme.breakpoints.up('lg')]: {
            marginTop: 0,
          },
          '& .MuiFormControl-root': {
            '& .MuiFormLabel-root': {
              top: '-9999px',
            },
            '& .MuiInputBase-root': {
              [theme.breakpoints.up('lg')]: {
                height: pxToRem(55),
              },
              '&.MuiInput-root': {
                marginTop: 10,
                borderWidth: '0 0 1px 0',
              },
              '& input': {
                ...paddingLR('0 !important', '0 !important'),
                paddingBottom: pxToRem(11),
                fontSize: `${fontSize.s16Rem}  !important`,
                lineHeight: `${fontSize.s24Rem}  !important`,

                [theme.breakpoints.up('lg')]: {
                  paddingBottom: pxToRem(18),
                  fontSize: `${fontSize.s22Rem}  !important`,
                  lineHeight: `${fontSize.s32Rem}  !important`,
                },
              },
              '&:hover': {
                background: theme.mixins.White(),
              },
              '& .MuiIconButton-label:after': {
                display: 'none',
              },
            },
          },
          '& .MuiAutocomplete-popperDisablePortal': {
            top: pxToRem(62),

            [theme.breakpoints.up('lg')]: {
              top: pxToRem(65),
            },
          },
        },
      },
    },
  };
});

export default useStyles;
